import { useAtomValue } from 'jotai'
import { cartAtom } from './cartState'

export default function useCart () {
  return useAtomValue(cartAtom)
}
